import Store from 'App/babel/store';

export default function allowed() {
	const state = Store.getState();
	const metadata = state.App.metadata;
	const features = state.App.accountSelf?.features;

	return features?.reports && (!metadata?.params.HideReportCenter || !features.looker);
}
